<ion-toolbar class="content-width" *ngIf="organisationId">
    <div class="season-select-center">
        <app-season-selector #seasonSelector [organisationId]="organisationId"></app-season-selector>
    </div>
</ion-toolbar>
@if (!isLoading) {
@for (tie of ties; let i = $index; track i;) {
<app-tie-scorecard isListView="true" [isLeagueOwner]="isLeagueOwner" [league]="league"
    [style.cursor]="tie?._id ? 'pointer' : 'default'" [tie]="tie" [isOwner]="isOwner" [isOfficial]="isOfficial"
    (click)="openTieDetails(i)"></app-tie-scorecard>
}

@if (!ties?.length) {
<app-empty-page [text]="noTeamMatchesText" iconName="people"></app-empty-page>
}
}
@if (isLoading) {
<div class="content-width ion-padding ion-text-center">
    <ion-spinner name="crescent"></ion-spinner>
</div>
}